import { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import "../../statusIcon.css";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { setEditingNote } from "../../redux/siteMonitoring/noteActions";
import InputWithChips from "../Input/InputWithChips";
import WarningIcon from "@mui/icons-material/Warning";
import moment from "moment";
import { formatNoteStatus } from "../../redux/siteMonitoring/siteMonitoringStatusActions";
import NoteStatusIcon from "./NoteStatusIcon";
import PhotoIcon from "@mui/icons-material/PhotoCamera";

class SiteMonitoringNote extends Component {
    displayNoteDetails() {
        if (this.props.previewMode) return;

        this.props.setEditingNote(this.props.note);
    }

    render() {
        let tagsAsChips = [];
        this.props.note.category_ids.forEach((tagId) => {
            let associatedTag = this.props.siteMonitoring.allowed_category_ids.find((t) => t.id === tagId);

            if (!associatedTag) return;

            tagsAsChips.push({ name: associatedTag.name, value: associatedTag.id, color: associatedTag.color });
        });

        let assignedUser = this.props.siteMonitoring.site_supervision_authorized_user_ids
            .map((au) => au.user_id)
            .find((u) => (u ? u.id === this.props.note.assigned_user_id : false));

        return (
            <div className="col-lg-4 col-md-6 col-sm-12 col-12 div-site-monitoring-card">
                <div ref={(divRef) => (this.divRef = divRef)}>
                    <Card className="col-lg-12 col-md-12 col-sm-12 col-12 card site-monitoring-card card-margin-top without-side-padding">
                        <CardContent
                            className="without-padding card-content-left-align"
                            onClick={this.displayNoteDetails.bind(this)}
                        >
                            <div>
                                <div className="row site-monitoring-card-body-margin">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 row">
                                        <div className="col-lg-9 col-md-9 col-sm-9 col-9 row without-side-padding">
                                            <InputWithChips
                                                chips={tagsAsChips}
                                                onClick={() => {}}
                                                multipleSelection={true}
                                                selectedValues={this.props.note.category_ids}
                                            />
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-3 col-3 without-side-padding">
                                            <span className="bold span-center">
                                                {assignedUser ? assignedUser.name : ""}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 row card-divider-div"></div>
                                    <div className="row">
                                        <div className="col-lg-8 col-md-6 col-sm-6 col-6 card-div-border-right">
                                            <div className="without-side-padding blue-text">
                                                <span className="bold">{this.props.note.name}</span>
                                                <span>
                                                    {(this.props.note.description && this.props.note.name ? " " : "") +
                                                        this.props.note.description}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-6 col-6 row">
                                            {this.props.note.date_deadline.isBefore(moment(), "day") ? (
                                                <div className="col-lg-3 col-md-3 col-sm-3 col-3 without-side-padding">
                                                    <WarningIcon color="secondary" style={{ fontSize: 25 }} />
                                                </div>
                                            ) : null}
                                            <div className="col-lg-9 col-md-9 col-sm-9 col-9 without-side-padding">
                                                <span>{this.props.note.date_deadline.format("DD/MM/YYYY")}</span>
                                            </div>
                                            <div className="col-lg-9 col-md-9 col-sm-9 col-9 without-side-padding card-div-border-right">
                                                <div className="span-center bold">
                                                    <div className="row">
                                                        <NoteStatusIcon state={this.props.note.state} />

                                                        <span>{formatNoteStatus(this.props.note.state)}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-3 col-3 without-side-padding">
                                                <div className="span-center bold">
                                                    {this.props.note.document_ids.some(
                                                        (d) => !d.deleted && d.id > 0
                                                    ) ? (
                                                        <PhotoIcon />
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        tags: state.tags.allTags,
        siteMonitoring: state.siteMonitoring.currentSiteMonitoring,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setEditingNote: (editingNote) => dispatch(setEditingNote(editingNote)),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(SiteMonitoringNote);
